import { render, staticRenderFns } from "./FairUnbox.vue?vue&type=template&id=3c8c618f&scoped=true"
import script from "./FairUnbox.vue?vue&type=script&lang=js"
export * from "./FairUnbox.vue?vue&type=script&lang=js"
import style0 from "./FairUnbox.vue?vue&type=style&index=0&id=3c8c618f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8c618f",
  null
  
)

export default component.exports